/**
 * 前端运行时环境（来自 Vite import.meta.env）。
 *
 * VITE_API_BASE_URL：
 * - dev 不设 → 用 vite proxy `/api/*` → http://localhost:3010
 * - production 设独立域 → https://api.admin.dosia.<域名>
 */
export const env = {
  API_BASE: import.meta.env.VITE_API_BASE_URL ?? "",
  /** DOSIA 桌面端下载页（「开始使用」邀请员工环节）。W2 官网上线后指官网下载页；
   *  默认先指 GitHub Releases。域名零硬编码原则：只改 env 不改代码。 */
  DOWNLOAD_URL:
    import.meta.env.VITE_DOSIA_DOWNLOAD_URL ??
    "https://github.com/leave1206/dosia/releases/latest",
} as const;
